import { ENVIRONMENTS, getCurrentEnvironment } from '@/utils/environmentUtils';

/**
 * Recaptcha site keys for the current environment
 * no need to add DEV key because it's the same as QA
 */
export const RECAPTCHA_SITE_KEYS = {
  [ENVIRONMENTS.PROD]: '6Lfm7JYoAAAAABm83WaOSfq4hGgcUu-pQtaaFcp5',
  [ENVIRONMENTS.QA]: '6LcaHjQoAAAAAGSfnGEEhBMTXz8BPqxz2NTIssO9',
  [ENVIRONMENTS.DEV]: '6LcaHjQoAAAAAGSfnGEEhBMTXz8BPqxz2NTIssO9',
};

export const getRecaptchaSiteKey = () => {
  return RECAPTCHA_SITE_KEYS[getCurrentEnvironment()];
};
